// extracted by mini-css-extract-plugin
export default {"editButton":"cashAllowance_editButton__Vl23U","TableBody":"cashAllowance_TableBody__7K5JW"};